export interface IFavoriteList {
  element_count: number;
  id: number;
  last_added_to_ts: number;
  name: string;
  brand_id: number;
}
